import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Organization } from "../organization";
import { SubCategory } from "../sub-category";
import { PositionEntityConfig } from "./config";
import { PositionFilters } from "./filters";
import { PositionMethods } from "./methods";

@HyperEntity("position", PositionEntityConfig)
export class Position extends extender(PositionFilters, PositionMethods) {
  @Fields.id()
  id = "";

  @Fields.string()
  name = "";

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne(() => Organization, { field: "organizationId" })
  organization?: Organization;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt: Date = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt: Date = new Date();

  @Fields.string({ dbName: "image_path" })
  imagePath = "";

  @Relations.toMany(() => SubCategory)
  subCategories: SubCategory[] = [];
}
